/**
 * Validate BGP MD5 Password.
 * Allowlist of printable ASCII characters (RFC 2385 / vendor consensus):
 * - skips \x20 (space)
 * - covers from \x21 ('!') to \x3E ('>') inclusive
 * - skips \x3F (question mark)
 * - covers from \x40 ('@') to \x7E ('~') inclusive
 * - Tabs, newlines, Unicode, and other non-ASCII characters are implicitly rejected.
 */
const isBgpPassword = (value) => /^[\x21-\x3E\x40-\x7E]*$/.test(value);

module.exports = {
  fn: isBgpPassword,
  message: 'BGP MD5 Password must use printable ASCII characters only, excluding spaces and question marks.',
  isBgpPassword
};
